// ═══════════════════════════════════════════════════════════════
//  Microsoft Entra SSO Configuration
//  Innocean USA — Campaign Performance Dashboard
// ═══════════════════════════════════════════════════════════════
//
//  To DISABLE SSO (public access), set ENABLE_SSO = false
//

export const ENABLE_SSO = true;

// Innocean Entra App Registration
export const CLIENT_ID = "261ad88f-f727-40d9-b1e1-62693577ff88";
export const TENANT_ID = "e9261556-ec76-4458-a16c-1fd225eb8d54";

// Usually don't need to change these
export const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`;
export const SCOPES = ["openid", "profile"];
